import type { ImageProps } from 'next/image';

const resolveSrc = (src: ImageProps['src']): string => {
  if (typeof src === 'string') {
    return src;
  }
  // `src` is typed as required, but content-driven callers can still spread
  // an incomplete object (e.g. missing test fixtures) at runtime.
  if (!src) {
    return '';
  }
  return 'default' in src ? src.default.src : src.src;
};

/**
 * Mirrors the `sites/*\/contentfulLoader.ts` custom image loader: true when
 * that loader would return the source unmodified (anything that isn't a
 * Contentful raster image), meaning next/image can't generate a real
 * width-based srcset for it and should be marked `unoptimized` instead —
 * otherwise it warns that the loader doesn't implement `width`.
 */
const needsUnoptimizedImage = (src: ImageProps['src']): boolean => {
  const url = resolveSrc(src);

  if (!url.includes('ctfassets.net')) {
    return true;
  }

  try {
    return new URL(url).pathname.toLowerCase().endsWith('.svg');
  } catch {
    return true;
  }
};

export { needsUnoptimizedImage };
